import axios from 'axios';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';
import { apiGateway } from 'src/config';
import { AnswerStatus } from 'src/constants';
import { useBearerToken } from './useBearerToken';

export interface AnswerHistoryAction5Entity {
  id: string;
  answerId: string | undefined | null;
  userId: string;
  userName: string | null;
  userNameEng: string | null;
  answerData: JSON;
  status: AnswerStatus;
  respondentTargetId: string;
  createdBy: string;
  createdAt: Date;
  updatedBy: string | null;
  updatedAt: Date | null;
}

export const useAnswerAction5Api = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { getBearerToken } = useBearerToken();
  /**
   * 回答履歴_アクション取得用のAPI
   * @param respondentTargetId
   * @returns
   */
  const getAnswerHistoryAction5 = async (respondentTargetId: string): Promise<AnswerHistoryAction5Entity[] | undefined> => {
    try {
      const token = await getBearerToken();
      const result = await axios.get<AnswerHistoryAction5Entity[]>(apiGateway + '/enquete-answer-input/answer-histories-action5/' + respondentTargetId, {
        headers: { Authorization: token },
        timeout: 60000,
      });
      return result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        enqueueSnackbar(t('apiExceptionMessage.useAnswerHistoryAction5Api.failedGetData'), { variant: 'error' });
      } else {
        throw error;
      }
    }
  };

  return {
    getAnswerHistoryAction5,
  };
};

